import type { ReactNode } from 'react';

/**
 * STITCH-2 pill badge primitive (DESIGN DIRECTION law (f)). Semantic tones
 * only -- identity never borrows status colors (03 P2); the 'pool' tone is
 * the dashed EMPTY SEAT (03 P6), visually distinct from every person and
 * every status.
 */
export type AcBadgeTone =
  | 'neutral'
  | 'info'
  | 'positive'
  | 'pending'
  | 'danger'
  | 'brand'
  | 'pool';

export interface AcBadgeProps {
  readonly tone?: AcBadgeTone;
  readonly children: ReactNode;
  readonly title?: string;
  readonly testId?: string;
}

export default function AcBadge({
  tone = 'neutral',
  children,
  title,
  testId,
}: AcBadgeProps) {
  return (
    <span className={`ac-badge ac-badge--${tone}`} title={title} data-testid={testId}>
      {children}
    </span>
  );
}
